import React from 'react';
import { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { createTaskSimple } from '../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { boardListSelectors } from '../../../../../app/resource/boards/boardList/boardList.selectors';
import { ITaskSimpleCreate } from '../../../../../app/resource/task-simple/task-simple.types';

import { IBoardTaskForm } from '../../../../../app/resource/task/task.types';

import { useRequiredValidation } from '../../../../../utils/form/validation.utils';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';

import { FormSmallTextInput } from '../../inputs/SmallTextInput';

import { IBoardTaskFormProps } from './types';

export const BoardTaskForm: FunctionComponent<IBoardTaskFormProps> = ({ boardListId, meetingId }) => {
  const dispatch = useDispatch();
  const userId = useSelect(authSelectors.selectLoggedUser);
  const boardList = useSelectWithParams(boardListSelectors.selectResourceById, boardListId);
  const formProps = useForm();

  const requiredValidation = useRequiredValidation();

  const onSubmit = (data: IBoardTaskForm) => {
    const newData: ITaskSimpleCreate = {
      title: data.title,
      description: '',
      userId: userId ? userId : '',
      meetingIds: [meetingId],
      status: '0',
      labels: [],
      members: [],
      showInTasks: '0',
      taskTypeId: boardListId,
      boardId: boardList?.boardId ?? '',
    };

    dispatch(createTaskSimple(newData));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="board-task-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as IBoardTaskForm))}
        method="post"
      >
        <div className="field-container">
          <FormSmallTextInput
            id="title"
            name="title"
            type="text"
            label="Card Title"
            placeholder="Enter Title"
            defaultValue=""
            validation={requiredValidation}
          />
        </div>
      </form>
    </FormProvider>
  );
};
